import { Badge, Flex, H3, P } from '@dnb/eufemia';
import { type JSX } from 'react';

import Card from '@/components/Card';
import { ApiCiamClientResponse } from '@/openapi/schema';

import style from './index.module.css';

export type CiamClientTileProps = {
  client: ApiCiamClientResponse;
};

export default function CiamClientTile({ client }: CiamClientTileProps): JSX.Element {
  return (
    <Card className={style['CiamClientTile']}>
      <Flex.Container stretch>
        <Flex.Item grow>
          <H3 bottom="small">{client.name || 'Unnamed Client'}</H3>
        </Flex.Item>
        <Badge content={client.liveMode ? 'Live' : 'Test'} status={client.liveMode ? 'positive' : 'default'} />
      </Flex.Container>
      <div className={style['InformationGrid']}>
        <P weight="medium">Client ID:</P>
        <P>{client.id}</P>
        <P weight="medium">Scopes:</P>
        <div className="flex justify-between items-end">
          <div>
            {client.scopes.map((s) => (
              <P key={s}>{s}</P>
            ))}
          </div>
          <P className={style['CiamOnlyLabel']} right="small" size="x-small">
            Not imported to portal
          </P>
        </div>
      </div>
    </Card>
  );
}
